/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit ReplacePatient/view.blocks to change it.
import * as fromFlow from 'Simple/Flow'
import No from './No/index'
import React from 'react'
import ReplaceDialog from './ReplaceDialog/index'
import TysiaButton from 'DesignSystem/TysiaButton/index'
import TysiaIconReplacePatient from 'DesignSystem/Svgs/TysiaIconReplacePatient/index'



/** @type {import('Simple/types.js').View} */
export default function ReplacePatient({
  children,
  viewPath = "/App/Account/Content/Settings/AdminContent/SettingsContent/IntegrationsApplications/Content/SyncPatients/Content/SyncPatients/Content/PatientCard/ReplacePatient",
  setOuterRef,
  left,
  top,
  setInnerRef,
  external_id
  
}) {
  let flow = fromFlow.useFlow()
  let flowValue = fromFlow.useFlowValue(viewPath) || 'No'
  let setFlowTo = fromFlow.useSetFlowTo(viewPath)
  return (<React.Fragment
>
<TysiaButton
  viewPath={`${viewPath}/TysiaButton`}
 height={20}
 type="ghost"
 cursor="pointer"
 innerRef={setOuterRef}
 onClick={flow.has(fromFlow.normalizePath(viewPath, 'ReplaceDialog')) ? () => setFlowTo(fromFlow.normalizePath(viewPath, 'No')) : () => setFlowTo(fromFlow.normalizePath(viewPath, 'ReplaceDialog'))}
>
{childProps => (
<TysiaIconReplacePatient
{...childProps}
  viewPath={`${viewPath}/TysiaIconReplacePatient`}
 height={20}
/>
)}
</TysiaButton>
<fromFlow.When is={flowValue === 'No'}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'ReplaceDialog'}>
<ReplaceDialog
  viewPath={`${viewPath}/ReplaceDialog`}
 left={left}
 top={top}
 innerRef={setInnerRef}
 external_id={external_id}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}